import React, { useEffect, useRef } from 'react';

import PropTypes from 'prop-types';

import classes from './FormButtonWrapper.module.css';
import cn from 'classnames';

// Mobile sticky action bar for a form's primary buttons (Submit / Continue / Verify).
// On desktop (>600px) it renders as a plain passthrough <div> with no styling. On
// mobile (<=600px) it becomes a fixed bar pinned to the bottom of the viewport, and
// on scroll it lifts itself above the page Footer (id="footer") by the overlap amount
// so the buttons never cover the footer.
const FormButtonWrapper = ({ children, className }) => {
    const wrapperRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            const wrapper = wrapperRef?.current;

            if (!wrapper) return;

            const footer = document.getElementById('footer');

            // only apply on mobile
            if (window?.innerWidth > 600) return;

            const footerRect = footer?.getBoundingClientRect();
            const windowHeight = window?.innerHeight;

            // if the footer is partially visible, move the wrapper up
            if (footerRect?.top < windowHeight) {
                const offset = Math.max(0, windowHeight - footerRect?.top);
                wrapper.style.bottom = `${offset}px`;
            } else {
                // Reset position when footer is out of view
                wrapper.style.bottom = '0px';
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div ref={wrapperRef} className={cn(classes.wrapper, className)}>
            {children}
        </div>
    );
};

FormButtonWrapper.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

export default FormButtonWrapper;
